import styled from 'styled-components';

export const Container = styled.div`
    padding: 32px 16px;
`;

export const GuidesListWrapper = styled.div`
    max-width: 400px;
    width: 100%;
    margin: 0 auto;
`;
